import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CoreMenuService } from '@core/components/core-menu/core-menu.service';
import { SchoolUniversity } from '../models/school/school-university';

@Injectable({ providedIn: 'root' })
export class CurrentSchoolUniversityService {
	currentSchoolSubject: BehaviorSubject<SchoolUniversity | null>;
	currentSchoolId: BehaviorSubject<string | null>;

	constructor(private _coreMenuService: CoreMenuService) {
		this.currentSchoolSubject = new BehaviorSubject<SchoolUniversity | null>(null);
		this.currentSchoolId = new BehaviorSubject<string | null>(null);

		if (this.getSchoolFromStorage()) {
			this.currentSchoolId.next(this.getSchoolFromStorage());
		}
	}

	changeSchool(school: SchoolUniversity, changeMenu: boolean = true) {
		if (changeMenu && this._coreMenuService.menuKeyExist('school')) {
			this._coreMenuService.setCurrentMenu('school');
		}

		sessionStorage.setItem('school', String(school.id));

		this.currentSchoolSubject.next(school);

		this.currentSchoolId.next(school.id);
	}

	getSchoolFromStorage(): string | null {
		return sessionStorage.getItem('school');
	}

	exitSchool(backOffice = true) {
		sessionStorage.removeItem('school');

		this.currentSchoolSubject.next(null);

		this.currentSchoolId.next(null);

		if (backOffice && this._coreMenuService.menuKeyExist('university')) {
			this._coreMenuService.setCurrentMenu('university');
		}
	}
}
